(function(){
  if (window.__shkWl) return; window.__shkWl = true;
  var KEY='SeWdh6', MAIN='ThUf7k', WAIT='RAcDCJ';
  function sub(email, list, source){
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KEY, {
      method: 'POST',
      headers: {'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-01-15'},
      body: JSON.stringify({data: {type: 'subscription', attributes: {
        custom_source: source,
        profile: {data: {type: 'profile', attributes: {email: email}}}
      }, relationships: {list: {data: {type: 'list', id: list}}}}})
    }).then(function(r){ if(!r.ok) throw new Error(r.status); });
  }
  document.addEventListener('submit', function(e){
    var f = e.target.closest ? e.target.closest('form.shk-wl') : null;
    if(!f) return;
    e.preventDefault();
    var input = f.querySelector('input[type=email]');
    var btn = f.querySelector('button');
    var msg = f.nextElementSibling;
    var email = (input.value || '').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
      msg.textContent = 'Please enter a valid email address.';
      input.focus();
      return;
    }
    btn.disabled = true;
    var product = f.getAttribute('data-product') || 'Website';
    var done = f.getAttribute('data-done') || 'Thank you. Check your inbox, and we will email you when the next batch is ready.';
    var source = 'Tell me first: ' + product;
    sub(email, MAIN, source).then(function(){
      return sub(email, WAIT, source).catch(function(){});
    }).then(function(){
      f.style.display = 'none';
      msg.textContent = done;
    }).catch(function(){
      btn.disabled = false;
      msg.textContent = 'Sorry, that did not work. Please try again.';
    });
  });
})();
